import { IDCodesLookupLayout } from "../../../../common/lookups/Layouts/IdLayouts";

export const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            { "name": "code", "tableName": "IDEXCEPTIONSHEADER", "label": "Code", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            { "name": "status", "tableName": "IDEXCEPTIONSHEADER", "label": "Status", "type": "select", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            { "name": "description1", "tableName": "IDEXCEPTIONSHEADER", "label": "Description 1", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            { "name": "description2", "tableName": "IDEXCEPTIONSHEADER", "label": "Description 2", "type": "text", "required": false, "visible": true, "isLabelChanged": false }
        ]
    },
    {
        "groupId": 5,
        "fields": [
            { "name": "userDefinedCode1", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 1", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4A' }), "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedCode2", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 2", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4B' }), "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedCode3", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 3", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4C' }), "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedCode4", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 4", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4D' }), "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedCode5", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 5", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4E' }), "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedDate1", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 1", "type": "date", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedDate2", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 2", "type": "date", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedDate3", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 3", "type": "date", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedDate4", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 4", "type": "date", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedDate5", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 5", "type": "date", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedQuantity1", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 1", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedQuantity2", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 2", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedQuantity3", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 3", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedQuantity4", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 4", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedQuantity5", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 5", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedReference1", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 1", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedReference2", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 2", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedReference3", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 3", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedReference4", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 4", "type": "text", "required": false, "visible": false, "isLabelChanged": false },
            { "name": "userDefinedReference5", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 5", "type": "text", "required": false, "visible": false, "isLabelChanged": false }
        ]
    }
];

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IDEXCEPTIONSHEADER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "CODE",
                "tableName": "IDEXCEPTIONSHEADER",
                "label": "Code",
                "type": "text",
                "required": true,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "IDEXCEPTIONSHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "DESCRIPTION1",
                "tableName": "IDEXCEPTIONSHEADER",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DESCRIPTION2",
                "tableName": "IDEXCEPTIONSHEADER",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "IDEXCEPTIONSHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];

export const UserDefinedCodesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            { "name": "USERDEFINEDCODE1", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 1", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4A' }), "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDCODE2", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 2", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4B' }), "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDCODE3", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 3", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4C' }), "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDCODE4", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 4", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4D' }), "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDCODE5", "tableName": "IDEXCEPTIONSHEADER", "label": "Code 5", "type": "lookup", "layout": IDCodesLookupLayout({ codeType: '4E' }), "required": false, "visible": true, "isLabelChanged": false },
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            { "name": "USERDEFINEDDATE1", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 1", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDDATE2", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 2", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDDATE3", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 3", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDDATE4", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 4", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDDATE5", "tableName": "IDEXCEPTIONSHEADER", "label": "Date 5", "type": "date", "required": false, "visible": true, "isLabelChanged": false },
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            { "name": "USERDEFINEDQUANTITY1", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 1", "type": "number", "format": "#0.00", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDQUANTITY2", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 2", "type": "number", "format": "#0.00", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDQUANTITY3", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 3", "type": "number", "format": "#0.00", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDQUANTITY4", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 4", "type": "number", "format": "#0.00", "required": false, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDQUANTITY5", "tableName": "IDEXCEPTIONSHEADER", "label": "Quantity 5", "type": "number", "format": "#0.00", "required": false, "visible": true, "isLabelChanged": false },
        ]
    }
];

export const UserDefinedReferencesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            { "name": "USERDEFINEDREFERENCE1", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 1", "type": "text", "required": false, "maxLength": 50, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDREFERENCE2", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 2", "type": "text", "required": false, "maxLength": 50, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDREFERENCE3", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 3", "type": "text", "required": false, "maxLength": 50, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDREFERENCE4", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 4", "type": "text", "required": false, "maxLength": 50, "visible": true, "isLabelChanged": false },
            { "name": "USERDEFINEDREFERENCE5", "tableName": "IDEXCEPTIONSHEADER", "label": "Reference 5", "type": "text", "required": false, "maxLength": 50, "visible": true, "isLabelChanged": false },
        ]
    }
];
